import script from "./Ichiran.vue?vue&type=script&setup=true&lang=js"
export * from "./Ichiran.vue?vue&type=script&setup=true&lang=js"

import "./Ichiran.vue?vue&type=style&index=0&id=1eaa05d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eaa05d8"]])

export default __exports__